import { customEvents } from '../utils/custom-events';
import { on, emit } from '../utils/events-actions';
import { isMobile } from '../utils/utils';

export default class Component{
    constructor(){
        this.name = this.constructor.name;
        this.$on = on;
        this.$emit = emit;
        this.$events = customEvents;
        this.$isMobile = isMobile;
    }
    init(){
        console.log(this.name);
    }
}